/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { mlsModuleReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export const mlsData = filterActions<
  ReturnType<typeof mlsModuleReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(mlsModuleReducer, whitelist)
